import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class ClodMsg extends Component {
    static displayName = ClodMsg.name;

    constructor(props) {
        super(props);
        this.Page_Size = Big3Common.WebConfig.Page_Size;
        this.state = {
            TotalCount:0,
            StartPage: 1,
            EndPage: this.Page_Size,
            NoticeList:[]
        };
        this.handleLink_Click = this.handleLink_Click.bind(this);
        this.handleAdd_Click = this.handleAdd_Click.bind(this);
        this.handleDtl_Click = this.handleDtl_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        
        //if (this.props.ContentState !== null && this.props.ContentState !== undefined) {
        //    Big3Common.setContentStateBind(this);
        //}
        //else {
        //    this.CallClodMsgData(1,10);
        //}
        this.CallClodMsgData(this.state.StartPage, this.state.EndPage);
    }
    async CallClodMsgData(StartPage, EndPage) {
        try {

            let Paging = { startpage: StartPage, endpage: EndPage, page_size: this.Page_Size }
            let Data = await Big3Common.Post('api/MyPage/Notice/GetNoticeMgtForClod', Paging);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let CallList = JSON.parse(Data.multiDataTable);
                let TotalCount = CallList.TotalCount;
                let NowNoticeList = this.state.NoticeList;
                CallList.DataList.map(list => NowNoticeList.push(list));
                this.setState({ NoticeList: NowNoticeList, TotalCount: TotalCount });   
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallClodMsgData: ", e)
        }
        return false;
    }
    handleLink_Click(event) {
        this.props.RenderComponent("AlertMsg");
        event.preventDefault();
    }
    handleAdd_Click() {
        let StartPage = this.state.StartPage + this.Page_Size;
        let EndPage = this.state.EndPage + this.Page_Size;
        this.setState({ StartPage: StartPage, EndPage: EndPage });
        this.CallClodMsgData(StartPage, EndPage);
    }
    handleDtl_Click(event,noti_idx, notino,wuid) {

        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["NoticeList"]);
        StateCopy.Noti_Idx = noti_idx;
        StateCopy.Notino = notino;
        StateCopy.WUid = wuid;
        this.props.RenderComponent("ClodMsgDtl", StateCopy);
        event.preventDefault();
    }
    render() {
        let NoticeList = this.state.NoticeList;
        return (
            <div>
                <div className="tap_box">
                    <div className="n_tap"><div className="alert_tap" onClick={this.handleLink_Click } >알림</div></div>
                    <div className="n_tap"><div className="alert_tap tap_on">Clo:D공지</div></div>
                </div>
                <div className="container_box a_margin d_padding ">
                    {NoticeList.map(list =>
                    
                        <div className="notice_content pointer"
                            key={list.noti_idx + '_' + list.notino.toString() + '_' + list.wuid}
                            onClick={(e)=>this.handleDtl_Click(e,list.noti_idx, list.notino,list.wuid) }
                        >
                            <div className="notice_title">{list.noti_title }</div>
                            <div className="notice_txt">{list.noti_contt}</div>
                            <div className="alert_time">{list.reg_dt}
                                {list.conf_yn === "Y" ? "" : <div className="alert_new"></div>}
                            </div>
                        </div>
                    )}
                </div>           
                <div className="more_button">
                    {
                        this.state.TotalCount > this.state.NoticeList.length ?
                            <button type="button" className="btn_v btn_inactive" onClick={this.handleAdd_Click }>더보기</button>
                            : ""
                    }
                </div>
            </div>
        );
    }
}
